// features/feedback/hooks/useSubmitPendingFeedback.ts
import axios from "axios";
import { useMutation, useQueryClient } from "react-query";
import { END_POINT } from "config/environment";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { QUERY_KEY_FOR_PENDING_FEEDBACK } from "./useGetPendingFeedback";

export interface SubmitFeedbackPayload {
  id: string;
  decision: "accepted" | "declined";
  comment?: string;
}

const submitFeedback = async (
  payload: SubmitFeedbackPayload,
  token?: string,
) => {
  const url = `${END_POINT.BASE_URL}/v1/job/feedback/talent-feedback`;

  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await axios.put(url, payload, config);
  return res.data;
};

export const useSubmitPendingFeedback = () => {
  const { token } = useGetUserInfo();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: SubmitFeedbackPayload) => submitFeedback(payload, token),
    {
      onSuccess: (data, variables) => {
        console.log("Feedback submitted successfully for job:", variables.id);

        queryClient.invalidateQueries(QUERY_KEY_FOR_PENDING_FEEDBACK);

        queryClient.refetchQueries(QUERY_KEY_FOR_PENDING_FEEDBACK);
      },
      onError: (error) => {
        console.error("Error submitting feedback:", error);
      },
    },
  );
};
